import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { noteActions } from '_actions';
import { DBDropDownObjective, DBTextFieldObjective, CancelButton } from '_components';
import styles from './Common.module.css'

class ObservationPalpationEntry extends React.Component {

    removePalpation() {
        this.props.removeChildRow(this.props.noteId, 'PTOBJECTIVEPALP', 'PA', this.props.palpEntry.PANO);
        if (!this.props.objUpdated) {
            this.props.updateBitField(this.props.noteId, 'PTNOTE', 'NTNO', this.props.pk, 'NTOBJECTIVEUPDATED', true);
        }
    }

    render() {
        let dropdownOptions = [
            { id: 'Pain', value: 'Pain' },
            { id: 'Increased Tone', value: 'Increased Tone' },
            { id: 'Decreased Tone', value: 'Decreased Tone' },
            { id: 'Normal', value: 'Normal' }
        ];

        return (
            <div>
                <div className={styles.textfield_row}>
                    <span className={styles.flag} />
                    <span className={styles.add_button} />
                    <DBTextFieldObjective
                        noteId={this.props.noteId}
                        entity='PTOBJECTIVEPALP'
                        entityKeyColumn='PANO'
                        entityKeyValue={this.props.id}
                        field='PANAME'
                        className={styles.palp_column_1}
                    />
                    <DBDropDownObjective
                        noteId={this.props.noteId}
                        entity='PTOBJECTIVEPALP'
                        entityKeyColumn='PANO'
                        entityKeyValue={this.props.id}
                        field='PAPALPATION'
                        className={styles.palp_column_2}
                        customOptions={dropdownOptions}
                    />
                    <DBTextFieldObjective
                        noteId={this.props.noteId}
                        entity='PTOBJECTIVEPALP'
                        entityKeyColumn='PANO'
                        entityKeyValue={this.props.id}
                        field='PACOMMENTS'
                        className={styles.palp_column_3}
                    />
                    <div className={styles.remove_button}>
                        <CancelButton title='Remove' size='extra-small' onClick={() => this.removePalpation()} />
                    </div>
                </div>
            </div>
        );
    }

}

function mapDispatchToProps(dispatch) {
    return {
        removeChildRow: bindActionCreators(noteActions.removeChildRow, dispatch)
    };
}

function mapStateToProps(state, ownprops) {
    let noteId = state.ui.patientTabs[state.ui.patientCenter[state.ui.patients.selectedPtno].selectedTab].noteId;
    let noteType = parseInt(noteId.split("_")[0]);
    let pk = parseInt(noteId.split("_")[1]);
    let oono = parseInt(Object.keys(state.entities.notes.PTOBJECTIVEOBS)
        .find(key => (state.entities.notes.PTOBJECTIVEOBS[key].OOEVNO === pk && noteType === 1)
            || (state.entities.notes.PTOBJECTIVEOBS[key].OONTNO === pk && noteType !== 1)));

    return {
        noteId: noteId,
        oono: oono,
        palpEntry: state.entities.notes.PTOBJECTIVEPALP[ownprops.id]
    };
}

const connectedObservationPalpationEntry = connect(mapStateToProps, mapDispatchToProps)(ObservationPalpationEntry);
export { connectedObservationPalpationEntry as ObservationPalpationEntry };


